// extracted by mini-css-extract-plugin
export default {"wrapper":"ConfirmModal_wrapper__MBqmK","title":"ConfirmModal_title__lJ1ZF","btn-box":"ConfirmModal_btn-box__sLq+n"};